// material
import { Box } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function Logo({ ...other }) {
  return (
    <Box
      component="img"
      alt="logo"
      //src="/static/brand/logo_single.svg"
      src="/static/brand/frigid.png"
      height={40}
      {...other}
    />
  );
}
